/**
 * Normalize an image entry — supports either a raw URL string or an object
 * { src, w, h, alt, caption }. Returns the object form.
 */
export const normalizeImage = (i, fallbackAlt = "") => {
  if (typeof i === "string") return { src: i, alt: fallbackAlt };
  return { alt: fallbackAlt, ...i };
};

/**
 * Returns an inline style object that pins a container to the image's native
 * aspect ratio (only when width + height are known).
 */
export const nativeAspectStyle = (img) =>
  img && img.w && img.h ? { aspectRatio: `${img.w} / ${img.h}` } : undefined;
